import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import { HiOutlineMail } from "react-icons/hi";
import styled from "styled-components";
import { getClipTitle } from "../clip/utils";
const StyledEmail = styled(HiOutlineMail)`
  color: #f8fcfd;
`;

export default function EmailShare({ link, clip, card, ...props }) {
  const subject = card ? card.ui.title : getClipTitle(clip);

  return (
    <ShareButton
      title="Share to Email"
      justifyContent={"center"}
      alignItems="center"
      flex={true}
      display="flex"
      target="_blank"
      href={`mailto:?subject=${subject}&body=${link}`}
      {...props}
    >
      <StyledEmail size={24}></StyledEmail>

      {props.children}
    </ShareButton>
  );
}
